import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "@tanstack/react-form";
import { Heading } from "src/components/base/heading";
import { Field, FieldGroup, Fieldset, RequiredLabel } from "src/components/base/fieldset";
import { Input } from "src/components/base/input";
import { Button, PrimaryButton } from "src/components/base/button";
import Form from "src/components/base/form";

/**
 * The properties for {@link ExternalTailscaleLogin}
 */
export type ExternalTailscaleLoginProps = {};

/**
 * Login component when a external user logs in via tailscale cli
 */
export default function ExternalTailscaleLogin(props: ExternalTailscaleLoginProps) {
    const [t] = useTranslation("static");

    const form = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
        validators: {
            onSubmitAsync: async () => {},
        },
    });

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <div className="w-full max-w-md rounded-xl border bg-white dark:border-zinc-800 dark:bg-zinc-900 dark:before:pointer-events-none forced-colors:outline">
                <div
                    className={
                        "grid h-full w-full place-items-start justify-items-center overflow-hidden p-6 py-8 sm:p-8 lg:p-12"
                    }
                >
                    <Heading>{t("heading.external-login")}</Heading>
                    <div className={"mt-6 flex w-full max-w-sm space-y-8 overflow-hidden p-1"}>
                        <Form onSubmit={form.handleSubmit} className={"flex w-full flex-col gap-8"}>
                            <Fieldset>
                                <FieldGroup>
                                    <form.Field name={"email"}>
                                        {(fieldApi) => (
                                            <Field className={"w-full"}>
                                                <RequiredLabel htmlFor={"email"}>{t("label.email")}</RequiredLabel>
                                                <Input
                                                    type={"email"}
                                                    value={fieldApi.state.value}
                                                    onChange={(e) => fieldApi.handleChange(e.target.value)}
                                                />
                                            </Field>
                                        )}
                                    </form.Field>
                                    <form.Field name={"password"}>
                                        {(fieldApi) => (
                                            <Field className={"w-full"}>
                                                <RequiredLabel htmlFor={"password"}>
                                                    {t("label.password")}
                                                </RequiredLabel>
                                                <Input
                                                    type={"password"}
                                                    value={fieldApi.state.value}
                                                    onChange={(e) => fieldApi.handleChange(e.target.value)}
                                                />
                                            </Field>
                                        )}
                                    </form.Field>
                                </FieldGroup>
                            </Fieldset>
                            <div className={"flex justify-between"}>
                                <Button
                                    href={"/s/tailscale-login/$token"}
                                    onClick={() => localStorage.removeItem("preferred-tailscale-login")}
                                >
                                    {t("button.go-back")}
                                </Button>
                                <PrimaryButton>{t("button.login")}</PrimaryButton>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/tailscale-login/$token/external-tailscale-login")({
    component: ExternalTailscaleLogin,
});
